export const GET_LIST_START = "@integrators/GET_LIST_START";
export const GET_LIST_SUCCESS = "@integrators/GET_LIST_SUCCESS";
export const GET_LIST_FAIL = "@integrators/GET_LIST_FAIL";
export const GET_DETAIL_START = "@integrators/GET_DETAIL_START";
export const GET_DETAIL_SUCCESS = "@integrators/GET_DETAIL_SUCCESS";
export const GET_DETAIL_FAIL = "@integrators/GET_DETAIL_FAIL";
export const GET_SETUPS_INTEGRATORID_START = "@integrators/GET_SETUPS_INTEGRATORID_START";
export const GET_SETUPS_INTEGRATORID_SUCCESS = "@integrators/GET_SETUPS_INTEGRATORID_SUCCESS";
export const GET_SETUPS_INTEGRATORID_FAIL = "@integrators/GET_SETUPS_INTEGRATORID_FAIL";
export const GET_WHITELISTED_IPS_INTEGRATORID_START = "@integrators/GET_WHITELISTED_IPS_INTEGRATORID_START";
export const GET_WHITELISTED_IPS_INTEGRATORID_SUCCESS = "@integrators/GET_WHITELISTED_IPS_INTEGRATORID_SUCCESS";
export const GET_WHITELISTED_IPS_INTEGRATORID_FAIL = "@integrators/GET_WHITELISTED_IPS_INTEGRATORID_FAIL";
